<template lang='pug'>
  script(type='application/ld+json' v-text='brandSchema' v-if='isBrand')
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BrandJsonSeoSchema',

  computed: {
    ...mapState({
      entity: state => state.product.entity,
      entityType: state => state.product.entityType,
      entityLoaded: state => state.product.entityLoaded
    }),

    isBrand () {
      return this.entityLoaded && this.entityType === 'brands'
    },

    brandSchema () {
      return {
        '@context': 'http://schema.org/',
        '@type': 'Brand',
        'name': this.entity.attributes['name'],
        'description': this.entity.attributes['description'],
        'url': `${window.config.domain}brands/${this.entity.attributes['slug-url']}`
      }
    }
  }
}

</script>
